export default __webpack_public_path__ + "static/media/m-icon-link-arrow-10-black.0f580edb.svg";